/* global __webpack_require__ */

// Set by vue.config.js and rsbuild.config.mjs for production builds, which ship each
// stylesheet unmirrored plus a right-to-left copy (scripts/rtl-stylesheets-webpack-plugin.js).
// Unset elsewhere, where the served CSS already carries both directions.
const RIGHT_TO_LEFT_SUFFIX = process.env.VUE_APP_RTL_STYLESHEET_SUFFIX || ''
// Folder of the built stylesheets under the public path: vue-cli's css/, or the one
// rsbuild.config.mjs defines.
const BUILT_STYLESHEET_FOLDER = process.env.VUE_APP_RTL_STYLESHEET_FOLDER || 'css/'

let switched = false

const toRightToLeftHref = (href, suffix = RIGHT_TO_LEFT_SUFFIX) => href.replace(/\.css(?=$|[?#])/, suffix)

const swapStylesheet = (link, suffix) => {
  const copy = link.cloneNode()
  copy.href = toRightToLeftHref(link.href, suffix)
  // Keep the original until the copy applies, so the page is never unstyled.
  copy.addEventListener('load', () => link.remove())
  copy.addEventListener('error', () => copy.remove())
  link.after(copy)
}

// A link still loading (e.g. a lazy chunk's) must not be removed before it settles: removing it
// cancels the load, so mini-css-extract never hears load or error and the chunk never resolves.
const swapStylesheetOnceLoaded = (link, suffix) => {
  if (link.sheet) swapStylesheet(link, suffix)
  else link.addEventListener('load', () => swapStylesheet(link, suffix), { once: true })
}

/**
 * Swaps the built stylesheets for their right-to-left copies, now and for every chunk loaded
 * later. One-way: the copies also carry the left-to-right rules, so switching back to a
 * left-to-right locale needs no swap.
 */
export const useRightToLeftStylesheets = ({
  doc = document,
  webpackRequire = typeof __webpack_require__ === 'function' ? __webpack_require__ : undefined,
  suffix = RIGHT_TO_LEFT_SUFFIX,
} = {}) => {
  if (switched || !suffix || !webpackRequire) return
  switched = true

  if (typeof webpackRequire.miniCssF === 'function') {
    const stylesheetOfChunk = webpackRequire.miniCssF
    // mini-css-extract resolves a chunk's stylesheet through this runtime hook at load time.
    // eslint-disable-next-line no-param-reassign
    webpackRequire.miniCssF = (chunkId) => toRightToLeftHref(stylesheetOfChunk(chunkId), suffix)
  }

  const builtStylesheets = new URL(`${webpackRequire.p}${BUILT_STYLESHEET_FOLDER}`, doc.baseURI).href
  doc.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
    if (link.href.startsWith(builtStylesheets)) swapStylesheetOnceLoaded(link, suffix)
  })
}
